import {getStationCode} from "../../network/NetworkUtil";
import {getAPIGatewayDataFromParent} from "../../handler/ParentDataHandler";
import {getFormattedTime, getRegion, logOperationalMetric} from "../../util/Util";
import {getUserName} from "../../handler/ParentDataHandler";
import {
    FORCE_STATUS,
    NONNULL_PLANNED_CYCLE_FIELD,
    DELIVERY_WINDOW_CONFIG_ALERTS,
    SORTATION_TYPE,
    DWC_ACTIONS,
    AMAZON_SUFFIX,
    REGION,
    ACCOUNT_ID, IS_USER_PERMITTED, CYCLE_TYPE
} from "../Constants";
import {NEWLINE_CHAR} from "../../util/Constants"
import {getWindowString, orderCycles} from "../Utils";

const metricProcessName = "SCC_INDUCT_MANAGEMENT";
const UNPROCESSED = "UNPROCESSED";
const PROCESSED = "PROCESSED";
const CANCELLED = "CANCELLED";
const ACTIVE = "ACTIVE";
const FAILED_UNDERPLANNED = "FAILED_UNDERPLANNED";

/**
* API to fetch list of all station cycles and all cycles with ForceInduct enabled details
* @param dispatcher
*/
export function fetchForceDetails(dispatcher) {
    getStationCycles(dispatcher);
    getForceCycles(dispatcher);
}

const getStationCyclesAPIGatewayRequest = (request) => {
    return {
        resourcePath: "/ivs/getStationCycles",
        httpMethod: "post",
        processName: "induct",
        requestBody: request
    }
}

const extractStationCyclesList = (result) => {
    const model = {
        stationCycleConfig: {}
    }
    if ("data" in result && "casCycleDetailsList" in result.data) {
        result.data.casCycleDetailsList.forEach(({id, name, cycleType}) => {
            if (!CYCLE_TYPE.includes(cycleType)) {
                model.stationCycleConfig[id] = name
            }
        });
    }
    return model;
}

const getStationCycles = (dispatcher) => {
    const request = {
        nodeId: getStationCode(),
    }
    const args = getStationCyclesAPIGatewayRequest(request);
    const startTime = Date.now();
    getAPIGatewayDataFromParent(args).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getStationCycles", true);
            dispatcher({type: "RECEIVE_DATA", data: extractStationCyclesList(result)});
        } else {
            logOperationalMetric(startTime, metricProcessName, "getStationCycles", false);
            dispatcher({type: "RECEIVE_DATA", data: []});
        }
    });
}

const getForceInductCyclesAPIGatewayRequest = (request) => {
    return {
        resourcePath: "/ivs/getForceInductCycles",
        httpMethod: "post",
        processName: "induct",
        requestBody: request
    }
}

const extractForceInductCyclesList = (result) => {
    const model = {
        forceCycleConfig: {}
    }
    if ("data" in result && "lmocsForceInductCyclesList" in result.data) {
        result.data.lmocsForceInductCyclesList.filter(({cycleName}) => cycleName!==null)
            .forEach((cycleDetail, index) => {
                model.forceCycleConfig[index] = {
                    cycleName: cycleDetail.cycleName,
                    node: cycleDetail.nodeId,
                    status: cycleDetail.status,
                    updatedBy: cycleDetail.userId
            }
        });
    }
    return model;
}

const getForceCycles = (dispatcher) => {
    const request = {
        nodeId: getStationCode(),
    }
    const args = getForceInductCyclesAPIGatewayRequest(request);
    const startTime = Date.now();
    getAPIGatewayDataFromParent(args).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getForceCycles", true);
            dispatcher({type: "RECEIVE_DATA", data: extractForceInductCyclesList(result)});
        } else {
            logOperationalMetric(startTime, metricProcessName, "getForceCycles", false);
            dispatcher({type: "RECEIVE_DATA", data: []});
        }
    });
}

const extractDRSPlanDetails = (nodeId, cycle, result) => {
    if (!("data" in result) || !("drsCycleDetailsList" in result.data)) {
        return null;
    }

    let cycleStatusString = null;
    let sortZonesUsedString = "";

    result.data.drsCycleDetailsList.forEach(cycleDetail => {
        let lastUpdatedTime = null;
        let cycleStatus = null;
        let isCancelled = false;
        let isProcessed = false;
        let isUnprocessed = false;
        let isFailed = false;
        cycleDetail.planDetailsList.forEach(planDetail => {
            if (planDetail.planStatus === UNPROCESSED) {
                isUnprocessed = true;
            } else if (planDetail.planStatus === PROCESSED
                || planDetail.planStatus === ACTIVE) {
                isProcessed = true;
                if (planDetail.numberOfContainersUsed > 0) {
                    //difference between number of bags and double bins gives the sort zone count
                    const sortZones = planDetail.numberOfContainersUsed - planDetail.numberOfDoubleBinsUsed
                    sortZonesUsedString = sortZonesUsedString.concat(sortZones, " Sort Zones, ", planDetail.numberOfContainersUsed , " Bags (" , planDetail.numberOfDoubleBinsUsed ," double bins) ");

                }
            } else if (planDetail.planStatus === CANCELLED) {
                isCancelled = true;
            } else if (planDetail.planStatus === FAILED_UNDERPLANNED) {
                isFailed = true;
            }

            if (lastUpdatedTime === null || planDetail.lastUpdatedTime > lastUpdatedTime) {
                lastUpdatedTime = planDetail.lastUpdatedTime;
            }
        });

        if (isUnprocessed) {
            cycleStatus = "NOT READY";
        } else if (isProcessed) {
            cycleStatus = "READY";
        } else if (isFailed) {
            cycleStatus = "FAILED UNDERPLANNED";
        } else if (isCancelled) {
            cycleStatus = "NOT READY";
        }

        cycleStatusString = cycleStatus + " - " + getFormattedTime(lastUpdatedTime)
        if(sortZonesUsedString !== "" ) {
            cycleStatusString = cycleStatusString + NEWLINE_CHAR + sortZonesUsedString
        }
    });

    return cycleStatusString;
}

/**
 * API to fetch DRS Plan Details in a Cycle.
 * @param cycleName Cycle Selected By The User.
 * @param nodeId Node Id of the station assigned to cycle.
 */
export function getDRSPlanDetails(cycleName, nodeId, dispatcher) {
    const request = {
        cycles: [cycleName],
        nodeId: nodeId
    }

    try {
        const args = setGetDRSPlanDetailsAPIGatewayRequest(request);
        const startTime = Date.now();
        getAPIGatewayDataFromParent(args).then(result => {
            if (result.status === 200) {
                logOperationalMetric(startTime, metricProcessName, "getDRSPlanDetails", true);
                dispatcher({
                        type: "RECEIVE_DATA_DRS",
                        data: extractDRSPlanDetails(nodeId, cycleName, result),
                        cycleInfo: cycleName + '~' + nodeId
                });
            } else {
                logOperationalMetric(startTime, metricProcessName, "getDRSPlanDetails", false);
            }
        });

    } catch (e) {
        return null;
    }
}

/**
 * API to fetch ENABLE/DISABLE force induct on a cycle
 * @param params
 * @param dispatcher
 */
export const enableForceInduct = (params, dispatcher) => {
    setForceCycle(params, FORCE_STATUS.ENABLED, dispatcher)
}

export const disableForceInduct = (params, dispatcher) => {
    setForceCycle(params, FORCE_STATUS.DISABLED, dispatcher)
}

export const automateForceInduct = (params, dispatcher) => {
    setForceCycle(params, FORCE_STATUS.AUTOMATED, dispatcher)
}

const setForceCycleAPIGatewayRequest = (request) => {
    return {
        resourcePath: "ivs/setForceInductCycle",
        httpMethod: "post",
        processName: "induct",
        requestBody: request
    }
}

const setGetDRSPlanDetailsAPIGatewayRequest = (request) => {
    return {
        resourcePath: "ivs/getDRSPlanDetails",
        httpMethod: "post",
        processName: "induct",
        requestBody: request
    }
}

export const setForceCycle = (params, status, dispatcher) => {
    const request = {
        ...params,
        status: status,
        nodeId: getStationCode()
    }
    const args = setForceCycleAPIGatewayRequest(request);
    const startTime = Date.now();
    getAPIGatewayDataFromParent(args).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "setForceCycle", true);
            dispatcher({type: "LOAD_VIEW", data: {dispatcher: dispatcher}});
        } else {
            logOperationalMetric(startTime, metricProcessName, "setForceCycle", false);
            dispatcher({
                type: "SET_ALERT",
                data: {
                    id: "inductmanagement.setForceError",
                    default: "Encountered an error while updating force induct for cycle: {cycleName}",
                    values: {cycleName: params.cycleName},
                    type: "error"
                }
            });
        }
    });
}

/**
 * API to fetch Child nodes of the current station and list of all active cycles in it
 * @param dispatcher
 */
export const fetchCycleManagementDetails = (dispatcher) => {
    getChildNodes(dispatcher);
    getActiveCycles(dispatcher);
}

const getActiveCyclesAPIGatewayRequest = (request) => {
    return {
        resourcePath: "/ivs/getActiveCycles",
        httpMethod: "post",
        processName: "induct",
        requestBody: request
    }
}

const extractActiveCycleDetails = (result) => {
    const model = {
        cycleConfig: {},
        isNodeEnabled: false,
        loadingCycle: false
    }
    if ("data" in result) {
        if ("lmocsCycleDetailsList" in result.data) {
            result.data.lmocsCycleDetailsList.forEach((cycleDetail, index) => {
                model.cycleConfig[index] = {
                    name: cycleDetail.cycleName,
                    type: SORTATION_TYPE[cycleDetail.sortationType],
                    forceInductStatus: cycleDetail.forceInductStatus,
                    assignedNode: cycleDetail.cycleCriteria.assignedNode,
                    activeUntilMillis: getFormattedTime(cycleDetail.activeUntilMillis)
                }
            });
        }
        if ("isNodeEnabled" in result.data) {
            model.isNodeEnabled = result.data.isNodeEnabled;
        }
    }
    return model;
}

export const getAllDRSPlans = (dispatcher, cyclesInfo) => {
    for (let i = 0; i < cyclesInfo.length; i++) {
        let cycleInfo = cyclesInfo[i];
        let cycleName = cycleInfo.split('~')[0];
        let node = cycleInfo.split('~')[1];
        getDRSPlanDetails(cycleName, node, dispatcher);
    }
}

const getActiveCycles = (dispatcher) => {
    const request = {
        nodeId: getStationCode()
    }
    const args = getActiveCyclesAPIGatewayRequest(request);
    const startTime = Date.now();
    getAPIGatewayDataFromParent(args).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getActiveCycles", true);
            dispatcher({type: "RECEIVE_DATA", data: extractActiveCycleDetails(result)});
        } else {
            logOperationalMetric(startTime, metricProcessName, "getActiveCycles", false);
            dispatcher({type: "RECEIVE_DATA", data: {isNodeEnabled: false, loadingCycle: false}});
        }
    });
}

const getChildNodesAPIGatewayRequest = (request) => {
    return {
        resourcePath: "/ivs/getChildNodes",
        httpMethod: "post",
        processName: "induct",
        requestBody: request
    }
}

const getChildNodes = (dispatcher) => {
    const request = {
        nodeId: getStationCode()
    }
    const model = {
        childNodes: [],
        loadingNode: false,
    }
    const args = getChildNodesAPIGatewayRequest(request);
    const startTime = Date.now();
    getAPIGatewayDataFromParent(args).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getChildNodes", true);
            model.childNodes = result.data.childNodeList;
            dispatcher({type: "RECEIVE_DATA", data: model});
        } else {
            logOperationalMetric(startTime, metricProcessName, "getChildNodes", false);
            dispatcher({type: "RECEIVE_DATA", data: {loadingNode: false}});
        }
    });
}

/**
 * API to retrieve all planned cycles list and associated details for a node
 * @param nodeId
 * @param dispatcher
 */
export const fetchPlannedCycles = (nodeId, dispatcher) => {
    getPlannedCycles(nodeId, dispatcher);
}

const getPlannedCyclesAPIGatewayRequest = (request) => {
    return {
        resourcePath: "ivs/getPlannedCycles",
        httpMethod: "post",
        processName: "induct",
        requestBody: request
    }
}

const extractPlannedCycleDetails = (result) => {
    const model = {
        plannedCycles: {}
    }
    if ("data" in result && "cycleDetailsList" in result.data) {
        result.data.cycleDetailsList
            // this API may return null values for cycleName and type. We filter those out
            .filter(cycleDetails => NONNULL_PLANNED_CYCLE_FIELD.every(field => cycleDetails[field]!==null))
            .forEach(cycleDetail => {
                model.plannedCycles[cycleDetail.cycleID] = {
                    name: cycleDetail.cycleName,
                    type: cycleDetail.sortationType,
                    state: cycleDetail.cycleState
            }
        });
    }
    return model;
}

const getPlannedCycles = (nodeId, dispatcher) => {
    const request = {
        nodeId: nodeId
    }
    const args = getPlannedCyclesAPIGatewayRequest(request);
    const startTime = Date.now();
    getAPIGatewayDataFromParent(args).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getPlannedCycles", true);
            dispatcher({type: "RECEIVE_DATA", data: extractPlannedCycleDetails(result)});
        } else {
            logOperationalMetric(startTime, metricProcessName, "getPlannedCycles", false);
            dispatcher({type: "RECEIVE_DATA", data: {plannedCycles: {}}});
        }
    });
}

/**
 * API to enable a particular cycle for a node/XPT
 * @param params
 * @param dispatcher
 */
export const enableSelectedCycle = (params, dispatcher) => {
    activateCycle(params, dispatcher)
}

const activateCycleAPIGatewayRequest = (request) => {
    return {
        resourcePath: "ivs/activateCycle",
        httpMethod: "post",
        processName: "induct",
        requestBody: request
    }
}

const activateCycle = (params, dispatcher) => {
    const request = {
        ...params,
        nodeId: getStationCode(),
    }
    const args = activateCycleAPIGatewayRequest(request);
    const startTime = Date.now();
    getAPIGatewayDataFromParent(args).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "activateCycle", true);
            dispatcher({type: "SET_VALUE", data: {selectedNodeId: "", selectedCycleId: ""}});
            dispatcher({type: "LOAD_VIEW", data: {dispatcher: dispatcher}});
        } else {
            logOperationalMetric(startTime, metricProcessName, "activateCycle", false);
            dispatcher({type: "SET_ALERT", data: {
                id: "inductmanagement.activateCycleError",
                default: "Encountered an error while activating cycle: {cycle}",
                values: {cycle: params.cycleName},
                type: "error"
            }});
        }
    });
}

/**
 * API to disable a particular cycle for a node/XPT
 * @param params
 * @param dispatcher
 */
export const disableSelectedCycle = (params, dispatcher) => {
    deactivateCycle(params, dispatcher)
}

const deactivateCycleAPIGatewayRequest = (request) => {
    return {
        resourcePath: "ivs/deactivateCycle",
        httpMethod: "post",
        processName: "induct",
        requestBody: request
    }
}

const deactivateCycle = (params, dispatcher) => {
    const request = {
        ...params,
        nodeId: getStationCode(),
    }
    const args = deactivateCycleAPIGatewayRequest(request);
    const startTime = Date.now();
    getAPIGatewayDataFromParent(args).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "deactivateCycle", true);
            dispatcher({type: "LOAD_VIEW", data: {dispatcher: dispatcher}});
        } else {
            logOperationalMetric(startTime, metricProcessName, "deactivateCycle", false);
            dispatcher({type: "SET_ALERT", data: {
                id: "inductmanagement.deactivateCycleError",
                default: "Encountered an error while deactivating cycle: {cycle}",
                values: {cycle: params.cycleName},
                type: "error"
            }});
        }
    });
}

/**
 * API to fetch cycle names and configuration for a station
 * @param dispatcher
 */
export const fetchDeliveryWindowConfigDetails = (dispatcher) => {
    getStationCycleNames(dispatcher)
    let userName = "";
    getUserName().then(response => {
        userName = JSON.parse(response.name)

        if (!userName.endsWith(AMAZON_SUFFIX)) {
            userName += AMAZON_SUFFIX;
        }
        getPackageCycleConfiguration(dispatcher, userName)
    })
}

const getStationCycleNames = (dispatcher) => {
    const request = {
        nodeId: getStationCode(),
    }
    const args = getStationCyclesAPIGatewayRequest(request);
    const startTime = Date.now();
    getAPIGatewayDataFromParent(args).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getStationCycleNames", true);
            dispatcher({type: DWC_ACTIONS.RECEIVE_DATA, data: extractStationCycleNames(result)});
        } else {
            logOperationalMetric(startTime, metricProcessName, "getStationCycleNames", false);
            dispatcher({type: DWC_ACTIONS.RECEIVE_DATA, data: {cycleList: []}});
        }
        dispatcher({type: DWC_ACTIONS.SET_VALUE, data: {loadingCycle: false}})
    });
}

const extractStationCycleNames = (result) => {
    const model = {
        cycleList: []
    }
    if ("data" in result && "casCycleDetailsList" in result.data) {
        result.data.casCycleDetailsList.forEach(({name}) => {
            model.cycleList.push(name)
        });
    }
    model.cycleList = orderCycles(model.cycleList)
    return model;
}

const getPackageCycleConfiguration = (dispatcher, userName) => {
    let accountID = ACCOUNT_ID.AMZN_UK;
    const region = getRegion();
    if (region === REGION.US) {
        accountID = ACCOUNT_ID.US_ROOT;
    } else if (region === REGION.FE) {
        accountID = ACCOUNT_ID.JP_AMZL_ROOT;
    }

    const request = {
        nodeId: getStationCode(),
        userId: userName,
        chloeAccountId: accountID,
        validateUserPermission: true
    }
    const args = getPackageCycleConfigurationAPIGatewayRequest(request);
    const startTime = Date.now();

    getAPIGatewayDataFromParent(args).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getPackageCycleConfiguration", true);
            dispatcher({type: DWC_ACTIONS.RECEIVE_DATA, data: convertAPIConfigToTableConfig(result)});
            if(IS_USER_PERMITTED in result.data) {
                dispatcher({type: DWC_ACTIONS.EDIT_ACCESS, data: result.data.isUserPermitted});
            }
        } else {
            logOperationalMetric(startTime, metricProcessName, "getPackageCycleConfiguration", false);
            dispatcher({type: DWC_ACTIONS.RECEIVE_DATA, data: {packageCycleConfig: {}, isNodeEnabled: false}})
            dispatcher({type: DWC_ACTIONS.SET_ALERT, data: DELIVERY_WINDOW_CONFIG_ALERTS.GET_CONFIG_FAIL})
        }
        dispatcher({type: DWC_ACTIONS.SET_VALUE, data: {loadingConfig: false}})
    });
}

const convertAPIConfigToTableConfig = (result) => {
    const model = {
        packageCycleConfig: {},
        isNodeEnabled: false
    }
    if ("data" in result) {
        if ("packageCycleConfig" in result.data) {
            Object.values(result.data.packageCycleConfig).forEach(({cycleName, deliveryWindows}) => {
                deliveryWindows.forEach((window) => {
                    let windowString = getWindowString(window)
                    if (model.packageCycleConfig.hasOwnProperty(windowString)) {
                        model.packageCycleConfig[windowString].cycleList.push(cycleName)
                    } else {
                        model.packageCycleConfig[windowString] = {window: window, cycleList: [cycleName]}
                    }
                })
            })
        }
        if ("isNodeEnabled" in result.data) {
            model.isNodeEnabled = result.data.isNodeEnabled;
        }
    }
    return model
}

const getPackageCycleConfigurationAPIGatewayRequest = (request) => {
    return {
        resourcePath: "/ivs/getPackageCycleConfiguration",
        httpMethod: "post",
        processName: "induct",
        requestBody: request
    }
}

/**
 * API to set the package cycle configuration
 * @param packageCycleConfig
 * @param dispatcher
 */
export const setConfiguration = (packageCycleConfig, dispatcher) => {
    setPackageCycleConfiguration(packageCycleConfig, dispatcher)
}

const setPackageCycleConfiguration = (packageCycleConfig, dispatcher) => {
    const request = {
        nodeId: getStationCode(),
        packageCycleConfig: convertTableConfigToAPIConfig(packageCycleConfig)
    }
    const args = setPackageCycleConfigurationAPIGatewayRequest(request);
    const startTime = Date.now();
    getAPIGatewayDataFromParent(args).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "setPackageCycleConfiguration", true);
            dispatcher({type: DWC_ACTIONS.SET_ALERT, data: DELIVERY_WINDOW_CONFIG_ALERTS.SAVE_SUCCESS});
        } else {
            logOperationalMetric(startTime, metricProcessName, "setPackageCycleConfiguration", false);
            dispatcher({type: DWC_ACTIONS.SET_ALERT, data: DELIVERY_WINDOW_CONFIG_ALERTS.SET_CONFIG_FAIL});
        }
        dispatcher({type: DWC_ACTIONS.LOAD_VIEW, data: {dispatcher: dispatcher}});
    });
}

const convertTableConfigToAPIConfig = (packageCycleConfig) => {
    const config = {}
    Object.values(packageCycleConfig).forEach(({window, cycleList}) => {
        cycleList.forEach((cycleName) => {
            if (config.hasOwnProperty(cycleName)) {
                config[cycleName].deliveryWindows.push(window)
            } else {
                config[cycleName] = {cycleName: cycleName, deliveryWindows: [window]}
            }
        })
    });
    return config
}

const setPackageCycleConfigurationAPIGatewayRequest = (request) => {
    return {
        resourcePath: "/ivs/setPackageCycleConfiguration",
        httpMethod: "post",
        processName: "induct",
        requestBody: request
    }
}


// WEBPACK FOOTER //
// ./src/components/inductmanagementv2/network/InductManagementNetworkAPI.js